import React, { Component } from "react";
import { FormattedDate } from "react-intl";

import Layout from "../../header_footer/Layout";
import Jumbotron from "../../utils/Jumbotron";

import axios from "axios";
import PropTypes from "prop-types";

class Aviso extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      aviso: {},
      path: "",
    };
  }

  componentDidMount = () => {
    this.loadAviso();
    let url = window.location.hostname;
    this.setState({ path: url });
  };

  loadAviso = async () => {
    let identifier = this.props.match.params.identifier;

    let res = {};
    try {
      res = await axios.get("/api/avisos/" + identifier, {
        headers: {
          APIKEY: "q7tXDJZX1StZAKZsKTLu5FRBs5k42vSf",
        },
      });
    } catch (error) {
      console.log(error);
    }

    if (res.data.aviso === null) {
      this.context.router.history.push("/not_found");
    }

    let aviso = res.data.aviso;
    this.setState({ aviso });
  };

  setWebsiteUrl = () => {
    return "http://"+(this.state.path + '/' + this.state.aviso.file);
    }

  render() {
    return (
      <Layout>
        <Jumbotron
          detalhe={this.state.aviso.type}
          title={this.state.aviso.title}
        />
        <div className="container">
          <div id="detalhe-restaurante" className="row">
            <div className="col-12 col-md-6 container-rich-text-description">
              <p
                className="poi-texto"
                dangerouslySetInnerHTML={{
                  __html: this.state.aviso.description,
                }}
              />
            </div>

            <div className="offset-md-2 col-12 col-md-4">
              <div className="box-shadow event-details-info">
                <p>
                  Data:
                  <span>
                    {this.state.aviso.date !== null && (
                      <FormattedDate
                        value={this.state.aviso.date}
                        year="numeric"
                        month="long"
                        day="2-digit"
                      />
                    )}
                  </span>
                </p>
              </div>

              {this.state.aviso &&
                this.state.aviso.file !== null &&
                this.state.aviso.file !== undefined &&
                this.state.aviso.file !== "" && (
                  <div className="box-shadow event-details-info">
                    
                    <a style={{color: "black"}} href={this.setWebsiteUrl()} target="_blank" rel="noopener noreferrer" ><p><i className="far fa-file-archive"></i>Download Anexos</p></a>
                  </div>
                )}
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

export default Aviso;
